import { FC } from 'react';

import { Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import defaultCountries from 'data/containers/countries';

import CountryPreview from 'components/CountryPreview';

import { useTranslation } from 'react-i18next';
import SelectCommon from '../common/SelectCommon/SelectCommon';
import { SelectValue } from '../filter.types';

const { Option } = Select;

interface CountrySelectProps {
  title: string;
  value: SelectValue;
  onChange: (value: SelectValue | undefined) => void;
  countries?: { code: string; label: string }[];
  isLoading?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  hasAccessToFilter?: boolean;
}

const CountrySelect: FC<CountrySelectProps> = ({
  title,
  value,
  onChange,
  countries = defaultCountries,
  isLoading = false,
  placeholder,
  className,
  disabled = false,
  hasAccessToFilter = false
}) => {
  const { t } = useTranslation();

  const countryPlaceholder = placeholder ?? t('common.label.enterCountry')

  const countriesOptions = countries.map((country) => (
    <Option key={country.code} value={country.code}>
      <CountryPreview countryCode={country.code} countryName={country.label} />
    </Option>
  ));

  const filterByCountryName = (input: string, option?: DefaultOptionType) => {
    return option?.props.children.props.countryName
      .toLowerCase()
      .includes(input.toLowerCase());
  };

  return (
    <SelectCommon
      title={title}
      value={value}
      placeholder={placeholder}
      customOptions={countriesOptions}
      onChange={onChange}
      filterOption={filterByCountryName}
      optionFilterProp="children"
      loading={isLoading}
      className={className}
      disabled={disabled}
      hasAccessToFilter={hasAccessToFilter}
    />
  );
};

export default CountrySelect;
